import { Component, Input } from "@angular/core";

@Component({
    selector:'app-poshvine-link',
    templateUrl:'./link.component.html',
    styleUrls:['./link.component.scss']
})
export class LinkComponent{
    @Input() type:'primary'|'secondary' = 'primary';
    @Input() navType: 'inbound'|'outbound' = 'inbound';
    @Input() labelText = '';
    @Input() isUnderlined = false;
    @Input() showIcons = true;
    constructor(){

    }
}